import styled, { css } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const VerticalTabMenuContainer = styled.div<{
  withBorder: boolean;
  fullWidth: boolean;
  withoutPadding: boolean;
  alignItems: 'start' | 'center';
}>`
  display: flex;
  flex-direction: column;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'min-content')};
  height: min-content;
  align-items: ${({ alignItems }) => alignItems};
  padding: ${({ withoutPadding }) => (withoutPadding ? 0 : SPACING._10)};
  border-radius: ${SPACING._16};
  gap: ${SPACING._8};

  ${({ withBorder, theme }) =>
    withBorder &&
    css`
      outline: 1px ${theme.neutral[800]} solid;
      outline-offset: -1px;
      box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
    `}

  > ul {
    display: flex;
    flex-direction: column;
    gap: ${SPACING._8};

    ${({ fullWidth }) =>
      fullWidth &&
      css`
        width: 100%;
      `}
  }
`;

export const LabelWrapper = styled.div`
  padding: ${SPACING._8};
  white-space: nowrap;
`;
